// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"fd929ccb","632":"ab02a97e","718":"3c1ca359","720":"a0dac27b","810":"00984ba9"}[chunkId] + ".css";
};